import React from 'react';
import { Document } from '@contentful/rich-text-types';
import { useLocation } from 'react-router-dom';

import { UserContent } from 'components/user-content/UserContent';
import { h2 } from 'styles/typography';
import { PartialRecord } from 'common/definitions/PartialRecord';
import { formatString } from 'common/utils/formatString';

export interface StepWrapperProps {
    heading: string;
    headingData?: PartialRecord<string, string>;
    subheading: Document | null;
    subheadingData?: PartialRecord<string, string>;
    contentClassName?: string;
}

export const StepWrapper = (props: React.PropsWithChildren<StepWrapperProps>) => {
    const { pathname } = useLocation();
    const isFirstPage = pathname.endsWith('/get-started');

    return (
        <div>
            <div className="max-w-2xl mx-auto px-4 sm:px-10">
                <div className="mb-4 sm:mb-8" />

                <h1
                    tabIndex={0}
                    className={[h2, isFirstPage ? 'text-center pt-[66px]' : ''].join(' ')}
                >
                    {props.headingData
                        ? formatString(props.heading, props.headingData)
                        : props.heading}
                </h1>

                <div className="mb-5" />

                {props.subheading ? (
                    <div className="text-dark-blue text-base font-normal leading-6">
                        <UserContent
                            className="space-y-3"
                            content={props.subheading}
                            data={props.subheadingData}
                        />
                    </div>
                ) : null}

                {props.children}
            </div>

            {!props.contentClassName ? <div className="mb-10" /> : null}
        </div>
    );
};
